import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   Link,
//   LinkIcon
// } from '../'
import Styles from './CompanyIsFlag.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsFlag extends Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }

  render() {
    return <div styleName='stat'>
      <div styleName='stat-count-wrapper'>
        <img
          src={this.props.icon}
          alt={this.props.title}
          styleName='stat-count'
        />
      </div>
      <div styleName={'stat-label ' + (this.props.color || '')}>
        {this.props.title}
      </div>
    </div>
  }
}

